import { FC } from "react";
import { useTranslation } from "react-i18next";

const Error: FC = () => {
  const { t } = useTranslation();
  return (
    <div className="error">
      <p>{t("general.error")}</p>
    </div>
  );
};

export default Error;
